import { Routes, Route, Navigate, Outlet } from 'react-router-dom'

import PortalThemeProvider from './components/PortalThemeProvider'
import ProtectedRoute from './components/ProtectedRoute'
import RoleGuard from './components/RoleGuard'
import AppLayout from './components/AppLayout'

import LoginPage from './pages/LoginPage'
import SsoCallbackPage from './pages/SsoCallbackPage'
import AppsPage from './pages/AppsPage'
import MyCloudFilesPage from './pages/MyCloudFilesPage'
import SessionsPage from './pages/SessionsPage'
import DownloadsPage from './pages/DownloadsPage'
import HelpPage from './pages/HelpPage'
import UserSettingsPage from './pages/UserSettingsPage'
import AdminDashboardPage from './pages/AdminDashboardPage'
import TicketsPage from './pages/TicketsPage'
import AdminSettingsPage from './pages/AdminSettingsPage'
import Html5LaunchPage from './pages/Html5LaunchPage'

function App() {
  return (
    <PortalThemeProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sso/callback" element={<SsoCallbackPage />} />
        <Route path="/html5-launch" element={<Html5LaunchPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AppLayout />}>
            <Route path="/apps" element={<AppsPage />} />
            <Route path="/files" element={<MyCloudFilesPage />} />
            <Route path="/sessions" element={<SessionsPage />} />
            <Route path="/downloads" element={<DownloadsPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/settings" element={<UserSettingsPage />} />
            <Route
              element={
                <RoleGuard allowedRoles={['admin']}>
                  <Outlet />
                </RoleGuard>
              }
            >
              <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
              <Route path="/admin/tickets" element={<TicketsPage />} />
              <Route path="/admin/settings" element={<AdminSettingsPage />} />
            </Route>
            <Route path="/" element={<Navigate to="/apps" replace />} />
          </Route>
        </Route>
      </Routes>
    </PortalThemeProvider>
  )
}

export default App
